import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AssetDashboardsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }

  getAssetDashboards() {
    return this.http.get<string>(this._url(`/GetDashboardAssetAsync`));
  }

  updateDashboardAssetPreference(model: any) {
    return this.client.put<string>(this._url(`/UpdateAssetDashboardAsync`), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Dashboards${v}`);
  }
}
